import { TypographyOptions } from "@mui/material/styles/createTypography";
import { Color, createTheme } from "@valenzinsights/core-component";

import { typography } from "./typography";

declare module "@mui/material/styles" {

	interface TypeBackground {
		paper: string;
		default: string;
		menubar: string;
		menubarInverted: string;
		menubarAlternateColor: string;
		sidebar: string;
		analytics?: {
			chart1?: string[];
			chart2?: string[];
			chart3?: string[];
			chart4?: string[];
			chart5?: string[];
			chart6?: string[];
		}

	}
	interface Palette {
		background: TypeBackground;
	}

	interface PaletteColor {
		lighter?: string;
		darker?: string;
	}

	interface SimplePaletteColorOptions {
		lighter?: string;
		darker?: string;
	}

	interface PaletteBackground {
		paper: string;
		default: string;
		menubar: string;
		menubarInverted: string;
		menubarAlternateColor: string;
		sidebar: string;
		analytics?: {
			chart1?: string[];
			chart2?: string[];
			chart3?: string[];
			chart4?: string[];
			chart5?: string[];
			chart6?: string[];
		}
	}

	interface PaletteOptions {
		background?: Partial<TypeBackground>;
		grey?: Partial<Color>;
		ternary?: Partial<PaletteColor>;

	}
}

const createCustomTheme = () => {
	return createTheme({
		palette: {
			primary: {
				lighter: "#FFF1E5",
				100: "#fee1c8",
				light: "#f79448",
				300: "#f47a33",
				main: "#f88d2b",
				500: "#f88d2b",
				dark: "#b3561b",
				700: "#d36c22",
				darker: "#9d4918",
				contrastText: "#FFFFFF",
			},
			secondary: {
				lighter: "#d8e4f4",
				100: "#D1DFF0",
				light: "#5496CB",
				300: "#97D5F5",
				main: "#238EC5",
				500: "#1B7BB0",
				dark: "#125075",
				700: "#0A4060",
				darker: "#072E48",
				contrastText: "#FFFFFF",
			},
			success: {
				lighter: "#cfe3db",
				light: "#97c7b7",
				main: "#57ad93",
				dark: "#49a585",
				darker: "#3a8a6b",
				contrastText: "#FFFFFF",
			},
			error: {
				lighter: "#FFE7E6",
				light: "#FFA39E",
				main: "#EA3A3A",
				dark: "#BA2E2E",
				darker: "#7A1F1F",
				contrastText: "#FFFFFF",
			},
			warning: {
				lighter: "#FFF8E5",
				light: "#FFE4A0",
				main: "#F58C29",
				dark: "#C46F21",
				darker: "#834A16",
				contrastText: "#000000",
			},
			info: {
				lighter: "#E5F4FF",
				light: "#9FD9FF",
				main: "#238EC5",
				dark: "#125075",
				darker: "#072E48",
				contrastText: "#FFFFFF",
			},
			grey: {
				50: "#f3f3f3",
				100: "#e0e2e2",
				200: "#d0d1d1",
				300: "#f0f0f0",
				400: "#c6c8c9",
				500: "#d0cdcf",
				600: "#9a989a",
				700: "#6e6e71",
				800: "#54575a",
			},
			ternary: {
				lighter: "#d2e6de",
				light: "#5496CB",
				main: "#49A585",
				dark: "#416573",
				darker: "#97C7B7",
				contrastText: "#FFFFFF",
			},
			common: {
				black: "#000000",
				white: "#FFFFFF",
			},
			text: {
				primary: "#212529",
				secondary: "#6C757D",
				disabled: "#ADB5BD",
			},
			action: {
				disabled: "#ADB5BD",
			},
			divider: "#DEE2E6",
			background: {
				paper: "#F8F9FA",
				default: "#F8F9FA",
				menubar: "#114E59",
				menubarInverted: "#FFFFFF",
				menubarAlternateColor: "#ff5733",
				sidebar: "#FFFFFF",
			}
		},
		typography: typography('"Gotham Rounded Book", Book') as TypographyOptions,

	});
};

export default createCustomTheme;

export const orangeTheme = createCustomTheme();
